module.exports = __webpack_public_path__ + "media/plastic_3.db148d89.mp3";